<template>
  <div class="topic-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="活动类型" prop="type">
          <el-radio-group v-model="form.type" :disabled="disabled">
            <el-radio :label="0">普通</el-radio>
            <el-radio :label="1">特邀</el-radio>
            <el-radio :label="2">组队</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.type === 0" label="是否为女性专场" prop="isFemaleActivity ">
          <el-radio-group v-model="form.isFemaleActivity" :disabled="disabled">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.type === 0 && form.isFemaleActivity !== 1" label="投放渠道" prop="deliveryChannel">
          <el-checkbox-group v-model="form.deliveryChannel" :disabled="disabled">
            <el-checkbox :label="0">天猫</el-checkbox>
            <el-checkbox :label="1">京东</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="活动标题" prop="name" style="width: 500px">
          <el-input v-model="form.name" placeholder="请输入活动标题，最多不超过14个字符" maxlength="14" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="所属活动系列" prop="actionIndicator" style="width:500px">
          <el-input v-model="form.actionIndicator" placeholder="请输入所属活动系列，最多不超过14个字符" maxlength="14" :disabled="disabled" />
        </el-form-item>
        <el-form-item v-if="form.type === 1" label="上传用户名单" :prop="form.type ? 'excelName' :''">

          <div class="coupon-upload flex">
            <div v-if="form.excelName" class="coupon_tip download-file" style="margin-right:10px">
              {{ form.excelName }}
            </div>
            <el-upload ref="uploader" class="uploader" action="" :show-file-list="false" :on-change="importCoupons" :auto-upload="false" :disabled="disabled">
              <el-button v-if="!form.excelName" size="small" type="primary">上传文件</el-button>
              <el-button v-else type="primary" size="small">重新上传</el-button>
            </el-upload>
            <div v-if="!form.excelName" class="coupon_tip upload_tips">仅支持上传*.xls、*.xlsx格式</div>
            <div v-if="!form.excelName" class="coupon_tip link-color download-template" style="margin-left:10px" @click="downloadFileTemplate">
              <i class="el-icon-document" />下载文件模板
            </div>
          </div>
        </el-form-item>
        <el-form-item label="活动日期" prop="time" style="width: 500px">
          <el-date-picker v-model="form.time" type="datetimerange" placeholder="请选择活动时间" prefix-icon="el-icon-date" class="custom-date" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="开放报名时间" prop="differDay" style="width: 500px">
          <div class="flex tips">活动开始前
            <el-input v-model="form.differDay" type="number" :min="0" :disabled="disabled" style="width:50px !important;margin: 0 10px" oninput="value=value.replace('/^[1-9]\d*$/','');if(value<0)value=0" @keydown.native="handleFixNaN" />天
          </div>
        </el-form-item>
        <el-form-item label="计算活动时长" prop="isCalculationDuration" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.isCalculationDuration" :label="0">否</el-radio>
            <el-radio v-model="form.isCalculationDuration" :label="1">是</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="报名截止时间" prop="registrationIsOver" style="width: 500px">
          <div class="flex tips">活动开始前
            <el-input v-model="form.registrationIsOver" type="number" :min="0" :disabled="disabled" style="width:50px !important;margin: 0 10px" oninput="value=value.replace('/^[1-9]\d*$/','')" @blur="handleCatchRegistrationIsOver($event)" @keydown.native="handleFixNaN" />天
          </div>
        </el-form-item>
        <el-form-item label="是否需要身份证号" prop="needIdCard" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.needIdCard" :label="0" :disabled="ditchDisabled[0]" @change="handleChangeRules">是</el-radio>
            <el-radio v-model="form.needIdCard" :label="1" :disabled="ditchDisabled[1]" @change="handleChangeRules">否</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="活动城市" prop="uaEventCityId" style="width:300px">
          <el-select v-model="form.uaEventCityId" popper-class="_uaEventCityId_" placeholder="请选择城市" :disabled="disabled" @change="handleCityChange">
            <el-option v-for="item in citySelectVO" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <div class="flex" style="flex-wrap:wrap;">
          <el-form-item label="活动地点" prop="address">
            <el-select v-model="form.address" popper-class="_address_" placeholder="请选择活动地点" @change="handleStoreChange($event)">
              <el-option v-for="item in addressList" :key="item.id" :label="item.name" :value="item.id" />
              <el-option label="其他" value="-99" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="form.address && !choozeOther" label="详细地址">
            <div>{{ addressText }}</div>
          </el-form-item>
          <div v-else-if="choozeOther" class="flex">
            <el-form-item :key="1" label="详细地址" :prop="choozeOther ? 'otherAddress' : ''">
              <el-input v-model="form.otherAddress" style="width:200px !important;margin-left:10px;margin-right:10px" />
            </el-form-item>
            <el-form-item style="margin-left:20px; margin-right:20px;" class="btn-form-item">
              <el-button type="primary" @click="openMap">打开地图</el-button>
            </el-form-item>
            <el-form-item :key="2" label="坐标" :prop="choozeOther ? 'location' : ''" class="lng-label">
              <el-input v-model="form.location" placeholder="请填写经纬度" style="width: 200px !important;" />
            </el-form-item>
          </div>

        </div>
        <el-form-item label="活动教练" prop="coachSelectVO" style="width: 100%">
          <CoachSelect v-model="form.coachSelectVO" :value.sync="form.coachSelectVO" :is-need-coach="form.isNeedCoach" @changeDisabled="handleChangeDisabled" />
        </el-form-item>
        <!-- <el-form-item v-if="form.type !== 1" label="最大参与人数" prop="totalAttendance" style="width: 500px">
          <el-input v-model="form.totalAttendance" placeholder="请输入最大参与人数" :disabled="disabled" />
        </el-form-item> -->
        <div v-if="form.type === 0" class="row-cont">
          <el-form-item label="活动人数" prop="participationNumber" style="width:300px">
            <el-input v-model.number="form.participationNumber" type="number" placeholder="请输入活动人数" maxlength="9" @input="value => form.participationNumber = parseInt(value)" />
          </el-form-item>
          <el-form-item label="老客人数" prop="oldTotalAttendance" style="width:300px">
            <el-input v-model.number="form.oldTotalAttendance" type="number" placeholder="请输入老客人数" maxlength="9" @input="value => form.oldTotalAttendance = parseInt(value)" @blur="handleRegParticipationNumber" />
          </el-form-item>
          <el-form-item label="h5报名人数" prop="h5TotalNumber" style="width:300px">
            <el-input v-model.number="form.h5TotalNumber" type="number" placeholder="请输入h5报名人数" maxlength="9" @input="value => form.h5TotalNumber = parseInt(value)" />
          </el-form-item>
          <el-form-item label="候补人数" prop="alternateTotalNumber" style="width:300px">
            <el-input v-model.number="form.alternateTotalNumber" type="number" placeholder="请输入候补人数" maxlength="9" @input="value => form.alternateTotalNumber = parseInt(value)" />
          </el-form-item>
        </div>
        <div v-if="form.type === 2" class="row-cont">
          <el-form-item label="最大团队数量" prop="maxTeam" style="width:300px">
            <el-input v-model.number="form.maxTeam" type="number" placeholder="请输入最大团队数量" maxlength="9" @input="value => form.maxTeam = parseInt(value)" />
          </el-form-item>
          <el-form-item label="最小团队数量" prop="minTeam" style="width:300px">
            <el-input v-model.number="form.minTeam" type="number" placeholder="请输入最小团队数量" maxlength="9" @input="value => form.minTeam = parseInt(value)" @blur="checkMaxOrMinTeam('maxTeam')" />
          </el-form-item>
        </div>
        <div v-if="form.type === 2" class="row-cont">
          <el-form-item label="组队最大人数" prop="maxTeamPeople" style="width:300px">
            <el-input v-model.number="form.maxTeamPeople" type="number" placeholder="请输入最大组队数量" maxlength="9" @input="value => form.maxTeamPeople = parseInt(value)" />
          </el-form-item>
          <el-form-item label="组队最小人数" prop="minTeamPeople" style="width:300px">
            <el-input v-model.number="form.minTeamPeople" type="number" placeholder="请输入最小组队数量" maxlength="9" @input="value => form.minTeamPeople = parseInt(value)" @blur="checkMaxOrMinTeam('maxTeamPeople')" />
          </el-form-item>
        </div>
        <el-form-item label="运动目标" prop="movingTarget" style="width:429px">
          <el-select v-model="form.movingTarget" popper-class="_movingTarget_" placeholder="请选择运动目标" multiple :disabled="disabled">
            <el-option v-for="item in movingSelectVO" :key="item.id" :label="item.tagName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="适合人群" prop="suitsTheCrowd" style="width:429px">
          <el-input v-model="form.suitsTheCrowd" placeholder="请输入适合人群" />
        </el-form-item>
        <el-form-item v-if="form.type === 0 || form.type === 2 " label="会员等级" prop="membershipLevel">
          <el-radio-group v-model="form.membershipLevel" :disabled="disabled">
            <el-radio :label="0">所有会员</el-radio>
            <el-radio :label="2">Lv2及以上</el-radio>
            <el-radio :label="3">Lv3及以上</el-radio>
            <el-radio :label="4">Lv4及以上</el-radio>
            <el-radio :label="5">Lv5等级</el-radio>
          </el-radio-group>

        </el-form-item>
        <el-form-item label="活动标签" prop="label" style="width:429px">
          <el-select v-model="form.label" popper-class="_label_" placeholder="请选择活动标签" :disabled="disabled">
            <el-option v-for="item in uaEventLabelSelectVOS" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="上传消费者券">
          <div class="coupon-uploader">
            <el-upload ref="uploaderQuan" class="uploader coupon-uploader" action="" :show-file-list="true" :on-remove="handleRemove" :on-change="(file, fileList) => {importCoupon(file, fileList)}" :auto-upload="false" :file-list="couponList">
              <el-button v-if="!form.excelNameVouchers" size="small" type="primary">选择文件</el-button>
              <el-button v-else size="small" type="primary">重新选择</el-button>
            </el-upload>
            <span class="coupon_tip">仅支持上传*.xls、*.xlsx格式</span>
            <a download class="download-file" href="https://uadev-1257321318.file.myqcloud.com/static/excel/virtualExchangeCodevirtualExchangeCodeTemplate.xlsx-1646222726071.xlsx">
              <i class="el-icon-document" />下载文件模板
            </a>
          </div>
        </el-form-item>
        <el-form-item label="活动介绍" prop="content" style="width: 100%">
          <el-input v-model="form.content" type="textarea" placeholder="请输入活动介绍" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="注意事项" prop="announcement" style="width: 100%">
          <el-input v-model="form.announcement" type="textarea" placeholder="请输入注意事项" :disabled="disabled" />
        </el-form-item>
        <!-- <el-form-item label="活动流程" prop="activityFlow" style="width: 100%;">
          <el-input v-model="form.activityFlow" type="textarea" :rows="4" placeholder="请输入活动流程" :disabled="disabled" />
        </el-form-item> -->
        <el-form-item label="是否在列表页展示" prop="isShow" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.isShow" :label="0">是</el-radio>
            <el-radio v-model="form.isShow" :label="1">否</el-radio>
          </div>
        </el-form-item>
        <!-- <el-form-item label="是否需要体测" prop="needBodyTest" style="width: 690px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.needBodyTest" :label="1">是</el-radio>
            <el-radio v-model="form.needBodyTest" :label="0">否</el-radio>
          </div>
          <div v-if="form.needBodyTest" class="form-radio-popup">
            <img src="@/assets/images/warning1.png" alt="">
            <div>选择「是」会触发订阅消息，通知用户活动开始前72h完成体测可凭报告现场领礼品</div>
          </div>
        </el-form-item> -->
        <el-form-item label="是否需要置顶" prop="isTop" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.isTop" :label="1">是</el-radio>
            <el-radio v-model="form.isTop" :label="0">否</el-radio>
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="activityImageVO" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :url="form.activityImageVO.activityListPagePicture" title="列表页图片" size-tips="360px*576px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'activityListPagePicture')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.activityImageVO.activityDetailsPageHeader" title="活动详情页头图" size-tips="1125px*1125px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'activityDetailsPageHeader')" @triggerReg="handleCheckReg" />
            <!-- <UploadImage :url="form.activityImageVO.recommendedPcturesOfRelevantActivities" title="相关活动推荐图片" size-tips="340px*200px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'recommendedPcturesOfRelevantActivities')" @triggerReg="handleCheckReg" /> -->
            <!-- <UploadImage :url="form.activityImageVO.myActivityListPictures" title="我的活动列表页图片" size-tips="162px*180px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'myActivityListPictures')" @triggerReg="handleCheckReg" /> -->
            <UploadImage :url="form.activityImageVO.shareCardImage" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareCardImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.activityImageVO.shareImage" title="活动长图分享图片" size-tips="849px*849px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareImage')" @triggerReg="handleCheckReg" />
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <RelatedProductsSetting ref="relatedProducts" :selected-products="selectedProducts" />
        <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
          <div class="flex btns">
            <el-button type="info" @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { ActivityUAStar } from '@/model/ActivityUAStar';
import { getFileType } from '@/common/js/util';
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import { filterCoach } from '@/filters';
import { validNumber } from '@/utils/validate';
import CoachSelect from "./select.vue";
import {
  activityDetails,
  addActivity,
  addressOfCityById,
} from '@/api/activity';
import RelatedProductsSetting from '@/components/RelatedProductsSetting';

export default {
  components: { RelatedProductsSetting, UploadImage, Dialog, CoachSelect },
  data() {
    const checkCoachSelectVO = (rule, value, callback) => {
      if (value && value.length) {
        const ids = [];
        value.some((item) => {
          if (item.id && ids.includes(item['id'])) {
            callback(new Error('请选择不重复的课程教练'));
          }
          ids.push(item['id']);
        });
      }
      callback();
    };
    return {
      form: new ActivityUAStar(),
      couponList: [],
      rules: {
        type: [
          { required: true, message: '请选择活动类型', trigger: 'change' },
        ],
        isFemaleActivity: [
          { required: true, message: '请选择是否为女性专场', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入活动标题', trigger: 'blur' },
        ],
        time: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
        ],
        registrationIsOver: [
          // { required: false, message: '请填写报名截止时间', trigger: 'blur' },
        ],
        uaEventCityId: [
          { required: true, message: '请选择活动城市', trigger: 'change' },
        ],
        excelName: [
          { required: true, message: '请上传文件', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请选择活动地点', trigger: 'change' },
        ],
        otherAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        totalAttendance: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入最大参与人数'));
              }
              setTimeout(() => {
                if (validNumber(value)) {
                  callback();
                } else {
                  callback(new Error('请输入数字'));
                }
              }, 100);
            }, trigger: 'blur',
          },
        ],
        coachSelectVO: [
          { required: false, message: "请选择课程教练", trigger: ["blur"] },
          { validator: checkCoachSelectVO, trigger: 'change' },
        ],
        participationNumber: [
          // { required: true, message: '请输入活动人数', trigger: 'blur' },
          {
            required: true, validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入活动人数'));
              }
              if (value < this.form.oldTotalAttendance) {
                callback(new Error('活动人数必须大于等于老客人数'));
              }
              callback();
            }, trigger: 'blur',
          },
        ],
        // newTotalAttendance: [
        //   { required: true, message: '请输入新客人数', trigger: 'blur' },
        // ],
        oldTotalAttendance: [
          { required: true, message: '请输入老客人数', trigger: 'blur' },
        ],
        h5TotalNumber: [
          { required: true, message: '请输入h5报名人数', trigger: 'blur' },
        ],
        alternateTotalNumber: [
          { required: true, message: '请输入候补人数', trigger: 'blur' },
        ],
        maxTeam: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入最大团队数量'));
              } else if (value && this.form.minTeam && value < this.form.minTeam) {
                callback(new Error('最大团队数量小于最小团队数量'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        minTeam: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入最小团队数量'));
              } else if (value && this.form.minTeam && value > this.form.maxTeam) {
                callback(new Error('最小团队数量大于最大团队数量'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        maxTeamPeople: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入组队最大人数'));
              } else if (value && this.form.minTeamPeople && value < this.form.minTeamPeople) {
                callback(new Error('组队最大人数小于组队最小人数'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        minTeamPeople: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === undefined || value === null) {
                callback(new Error('请输入组队最小人数'));
              } else if (value && this.form.maxTeamPeople && value > this.form.maxTeamPeople) {
                callback(new Error('组队最小人数大于组队最大人数'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        movingTarget: [
          { type: 'array', required: true, message: '请选择运动目标', trigger: 'change' },
        ],
        suitsTheCrowd: [
          { required: true, message: '请输入适合人群', trigger: 'change' },
        ],
        membershipLevel: [
          { required: true, message: '请选择会员等级', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入活动介绍', trigger: 'blur' },
        ],
        announcement: [
          { required: true, message: '请输入注意事项', trigger: 'blur' },
        ],
        location: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === '0,0') {
                callback(new Error('请输入经纬度'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ],
        activityImageVO: {
          required: true, validator: (rule, value, callback) => {
            const keys = [
              { key: 'activityListPagePicture', label: '列表页图片' },
              { key: 'activityDetailsPageHeader', label: '活动详情页头图' },
              { key: 'shareCardImage', label: '小程序分享卡片' },
              { key: 'shareImage', label: '活动长图分享图片' },
              // { key: 'recommendedPcturesOfRelevantActivities', label: '相关活动推荐图片' },
              // { key: 'myActivityListPictures', label: '我的活动列表页图片' },
            ];
            value.myActivityListPictures = ' ';
            value.recommendedPcturesOfRelevantActivities = ' ';

            for (const { key, label } of keys) {
              if (!value[key]) {
                callback(new Error(`请上传${label}`));
              }
            }
            callback();
          }, trigger: ['change'],
        },
      },
      addressList: [],
      coachList: [],
      savePath: 'ua_activity/detail/',
      formDialogShow: false,
      information: {},
      uploadedFile: false,
      addressText: '',
      choozeOther: false,
      cancelText: '',
      activityId: '',
      isValidationTriggered: false,
      selectedProducts: [],
    };
  },
  computed: {
    ...mapState('activity',
      ['citySelectVO',
        'addressSelectVO',
        'coachSelectVO',
        'equipmentSelectVO',
        'movingSelectVO',
        'uaEventLabelSelectVOS',
        'coachLevalVO',
      ]),
    name() {
      return function (item) {
        return item.firstName + item.lastName;
      };
    },
    disabled() {
      // return [0, 2, 4].indexOf(this.form.status) !== -1;
      return false;
    },
    ditchDisabled() {
      if (this.form.type !== 0) {
        return [false, false];
      }
      if (this.form.isFemaleActivity === 1) {
        this.form.needIdCard = 0;
        this.form.deliveryChannel = [];
        this.handleChangeRules(this.form.needIdCard);
        return [false, true]; // 只有这里的数组需要第二个值，其他默认false
      }
      const hasDeliveryChannel = this.form.deliveryChannel.length > 0;
      this.form.needIdCard = hasDeliveryChannel ? 1 : this.form.needIdCard;
      return [hasDeliveryChannel, false];
    },
  },
  watch: {
    'form': {
      handler(val) {
        this.choozeOther = val.address === '-99';
      },
      deep: true,
    },
    "form.type": {
      deep: true,
      handler(newVal, oldVal) {
        this.$refs.form.clearValidate();
      },
    },
  },
  mounted() {
    const { query } = this.$route;
    const id = query.id || query.copyid;
    if (query.id || query.copyid) {
      this.getActivityDetail(id);
    }
    this.cancelText = query.id ? '编辑' : '新增';
    this.activityId = query.id ? query.id : '';
    this.getSelect();
  },
  methods: {
    ...mapActions('activity', ['getSelect']),
    handleChangeDisabled(e) {
      this.form.isNeedCoach = e ? 1 : 0;
    },
    handleCatchRegistrationIsOver(event) {
      if (event.target.value === '') {
        this.form.registrationIsOver = this.form.needIdCard === 0 ? 1 : 0;
      }
    },
    // 测试最大最小团队数量/团队人数
    checkMaxOrMinTeam(key) {
      this.$refs.form.validateField([key], valid => {
        if (valid) {
          // 校验不通过
          return;
        }
      });
    },
    handleRegParticipationNumber() {
      this.$refs.form.validate('participationNumber').then(res => {
        if (res) return;
      }).catch(err => {
        console.error(err);
      });
    },
    handleRemove(file, fileList) {
      if (!fileList.length) {
        this.form.excelNameVouchers = '';
        this.form.urlVouchers = '';
        this.form.consumerVouchers = '';
        this.couponList = [];
      }
    },
    handleCheckReg() {
      this.$refs.form.validateField("activityImageVO");
    },
    handleFixNaN(e) {
      const { key } = e;
      if (key === 'e' || key === '.') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    handleChangeRules(val) {
      if (val === 0) {
        this.rules.registrationIsOver = [
          {
            required: true, validator: (rule, value, callback) => {
              if (!value || value < 1) {
                callback(new Error('至少需要提前一天'));
              } else {
                callback();
              }
            }, trigger: 'blur',
          },
        ];
      } else {
        this.rules.registrationIsOver = [
          { required: false, message: '请填写报名截止时间', trigger: 'blur' },
        ];
      }
      if (!this.isValidationTriggered) {
        this.isValidationTriggered = true;
        this.$nextTick(() => {
          this.$refs.form.validateField("registrationIsOver");
        });
      }
    },
    getActivityDetail(id) {
      activityDetails(id)
        .then((data) => {
          this.addressText = data.address && data.address.address;
          this.getAddressList(data.uaEventCityId);
          if (data.coachSelectVO) {
            this.coachList = filterCoach(this.coachSelectVO, data.coachSelectVO.level);
          }
          this.form = new ActivityUAStar(data);
          if (data.otherAddress) {
            this.form.address = '-99'; // 详情页选择其他
          }
          // 回显消费者券
          data.nameOfTheVirtualCouponExcel && (this.couponList = [{ name: data.nameOfTheVirtualCouponExcel }]);
          // 复制活动不带消费者券
          if (this.$route.query.copyid) {
            this.form.excelNameVouchers = null;
            this.couponList = [];
          }
          this.selectedProducts = data.equipmentSelectVO || [];
          this.rules = {
            ...this.rules,
            registrationIsOver: this.form.needIdCard === 0 ? [
              {
                required: true, validator: (rule, value, callback) => {
                  if (!value || value < 1) {
                    callback(new Error('需要提前至少一天'));
                  } else {
                    callback();
                  }
                }, trigger: 'blur',
              },
            ] : [
              { required: false, message: '请填写报名截止时间', trigger: 'blur' },
            ],
          };
        });
    },
    getAddressList(cityId) {
      addressOfCityById(cityId)
        .then((data) => {
          this.addressList = [...data];
        });
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意活动状态，保存后已发布的活动信息将实时更新至UA HOUSE小程序",
      };
    },
    addActivity() {
      if (this.$route.query.copyid) {
        this.form.id = '';
      }
      const formData = new FormData();
      formData.append('file', this.form.file || null);
      formData.append('consumerVouchers', this.form.consumerVouchers || null);
      const param = { ...this.form };
      delete param.file;
      // 特邀情况下，没有新客老客字段
      if (param.type === 1) {
        param.newTotalAttendance = 0;
        param.oldTotalAttendance = 0;
        param.h5TotalNumber = 0;
      }
      // delete param.coachLevel
      if (param.address === '-99') {
        param.address = '';
      } else {
        param.otherAddress = '';
      }
      param.coachIds = [];
      param.coachSelectVO.forEach((item, index) => {
        item.id && param.coachIds.push(item.id);
        if (item.id && item.level && !param.coachLevel) {
          param.coachLevel = item.level;
        } else if (param.coachSelectVO.length === 1 && item.level) {
          param.coachLevel = item.level;
        }
      });

      delete param.coachSelectVO;
      // 处理无教练活动
      if (param.isNeedCoach === 1) {
        delete param.coachIds;
      }
      const ref = this.$refs.relatedProducts;
      param.recommendEquipments = ref.addList.map(item => item.productNo);
      console.info('活动参数', JSON.stringify(param));
      formData.append('uaActivityAddDTO', new Blob([JSON.stringify(param)], { type: 'application/json' }));
      addActivity(formData).then((data) => {
        this.$message.success(`${this.cancelText}成功`);
        setTimeout(() => {
          this.goBack();
        }, 2000);
      }).catch(err => {
        if (err && !err.success) {
          console.error(err.errorMessage || `${this.cancelText}失败`);
          // this.$message.error(err.errorMessage || `${this.cancelText}失败`);
        }
      });
    },
    // 导入消费券
    importCoupon(file, fileList) {
      if (getFileType(file.raw.name) !== 'excel') {
        this.$message.error('导入失败，请选择Excel文件');
        this.$refs.uploaderQuan.clearFiles();
        return;
      }
      if (fileList && fileList.length >= 2) {
        fileList.shift();
      }
      this.$Api.uploadFile.uploadExcel(file.raw, 'ua_activity/detail/').then(data => {
        this.uploadLoading = false;
        this.form.consumerVouchers = file.raw;
        this.form.excelNameVouchers = file.raw.name;
        this.form.urlVouchers = data;
        this.couponList = [file];
        this.$message.success('上传成功');
      }).catch(err => {
        this.form.consumerVouchers = null;
        this.form.excelNameVouchers = '';
        this.form.urlVouchers = '';
        console.error(err);
      });
    },
    // 导入用户名单
    importCoupons(file) {
      if (getFileType(file.raw.name) !== 'excel') {
        this.$message.error('导入失败，请选择Excel文件');
        this.$refs.uploader.clearFiles();
        return;
      }
      this.$Api.uploadFile.uploadExcel(file.raw, 'ua_activity/detail/').then(data => {
        this.uploadLoading = false;
        this.form.file = file.raw;
        this.form.excelName = file.raw.name;
        this.form.url = data;
        this.$message.success('上传成功');
        this.uploadedFile = true;
      }).catch(err => {
        this.form.file = null;
        this.form.excelName = '';
        this.form.url = '';
        console.error(err);
      });
    },

    downloadFileTemplate() {
      // 下载
      window.open('https://uadev-1257321318.file.myqcloud.com/static/excelactivityUserListTemplate.xlsx-1646222983676.xlsx');
    },
    uploader(file, key) {
      this.form.activityImageVO[key] = file;
      this.$forceUpdate();
    },

    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    handleCityChange(val) {
      this.form.address = '';
      this.getAddressList(val);
    },
    handleStoreChange(val) {
      console.info('change', val);
      const data = this.addressList.filter((item) => item.id === val);
      this.addressText = data[0] && data[0].address;
    },
    handleCoachLevelChange(val) {
      console.info(val);
      this.form.coachLevel = val;
      this.form.coachId = '';
      this.coachList = filterCoach(this.coachSelectVO, val);
      console.info(this.coachSelectVO);
      console.info(this.coachList);
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'delete') {
        this.goBack();
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addActivity();
          } else {
            return false;
          }
        });
      }
    },
    goBack() {
      this.$router.back(-1);
    },
  },
};

</script>
<style lang="less" scoped>
.row-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.form-radio-popup {
  width: auto;
  height: 36px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid #caa670;
  background: #caa670;
  margin-top: 10px;
  display: flex;
  align-items: center;

  > div {
    line-height: 36px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }

  > img {
    width: 14px;
    height: 14px;
    margin-right: 8px;
  }
}
.btns {
  align-items: center;
  justify-content: center;
}
.marginTop {
  margin-top: 30px;
}
</style>
<style lang="less">
.topic-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
    .form-radio {
      line-height: 32px;
      height: 32px;
      align-items: center;
    }
    .el-checkbox__inner::after {
      border-right-width: 2.5px;
      border-bottom-width: 2.5px;
    }
    .el-checkbox__label {
      color: #494949;
    }
    .coupon-uploader {
      margin: unset;
      display: flex;
      height: 34px;
      line-height: 34px;
      .el-button {
        width: 115px;
        height: 34px;
      }
      .coupon_tip {
        width: 250px;
        white-space: nowrap;
        margin-left: 10px;
        margin-right: 20px;
      }
      .download-file {
        white-space: nowrap;
      }
    }
  }
  .coach-select-box + .el-form-item__error {
    top: unset !important;
    bottom: 43px !important;
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .form-icon {
    margin-left: 10px;
    .el-icon-close {
      color: #9b9b9b;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }
  .btn-reset {
    margin-left: 10px;
    cursor: pointer;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #0085d0;
  }
  .form-add {
    margin-top: 24px;
    .el-button {
      border: 1px dashed #bbbbbb;
      i {
        color: #bbbbbb;
      }
      span {
        color: #bbbbbb;
      }
    }
  }
  .product-config,
  .image-config {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .lng-label .el-form-item__label {
    width: 50px !important;
  }
  .lng-label .el-form-item__content {
    margin-left: 50px !important;
  }
  .btn-form-item.el-form-item--small {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>

